import { enemyHealth, makeEnemy } from './boss';
import { nextRandom } from './rng';
import type { GameState } from './types';

/** Odległość przeklętej skrzyni od bohatera i promień kręgu strażników. */
const CHEST_DISTANCE = 320;
const GUARD_RING = 90;

const between = (s: GameState, [a, b]: readonly [number, number]) => a + nextRandom(s) * (b - a);

/** Pierwsze odliczanie do wydarzenia (Infinity, gdy dane nie mają wydarzeń). */
export function firstRunEvent(s: Pick<GameState, 'content'>): number {
  return s.content.game.runEvents?.first ?? Number.POSITIVE_INFINITY;
}

/**
 * Wydarzenia wyprawy (game.runEvents): co jakiś czas mgła, przeklęta skrzynia albo krwawy księżyc.
 * W czasie walki z bossem nowe wydarzenie czeka.
 */
export function updateRunEvents(s: GameState, dt: number): void {
  const cfg = s.content.game.runEvents;
  if (!cfg) return;
  const ev = s.runEvent;
  if (ev) {
    ev.left -= dt;
    const def = cfg.list.find((d) => d.id === ev.id);
    // Krwawy księżyc: wrogowie pojawiają się szybciej (licznik pojawiania się biegnie szybciej).
    if (def?.kind === 'frenzy') s.spawnTimer -= dt * def.spawnBoost;
    if (ev.left <= 0) {
      s.runEvent = null;
      s.events.push({ type: 'runEventEnd', id: ev.id });
    }
    return;
  }
  s.runEventTimer -= dt;
  if (s.runEventTimer > 0 || s.bossIds.length > 0) return;
  s.runEventTimer = between(s, cfg.interval);
  const def = cfg.list[Math.floor(nextRandom(s) * cfg.list.length)]!;
  s.runEvent = { id: def.id, kind: def.kind, left: def.duration, duration: def.duration };
  if (def.kind === 'cursedChest') cursedChest(s, def.guards);
  s.events.push({ type: 'runEventStart', id: def.id, name: def.name, description: def.description, kind: def.kind, duration: def.duration });
}

/** Skrzynia w pobliżu, otoczona kręgiem strażników ze strefy (najtwardszy zwykły wróg). */
function cursedChest(s: GameState, guards: number): void {
  const angle = nextRandom(s) * Math.PI * 2;
  const x = s.player.x + Math.cos(angle) * CHEST_DISTANCE;
  const y = s.player.y + Math.sin(angle) * CHEST_DISTANCE;
  s.chests.push({ id: s.nextId++, x, y });
  const zone = s.content.zones[s.zoneId]!;
  const pool = zone.enemies.map((z) => s.content.enemies[z.enemy]!).filter((d) => d.behavior !== 'boss' && d.behavior !== 'exploder');
  const guard = pool.reduce((best, d) => (d.health > best.health ? d : best), pool[0]!);
  // Strażnicy to mieszanka: co trzeci najtwardszy, reszta losowo ze strefy.
  for (let i = 0; i < guards; i++) {
    const def = i % 3 === 0 ? guard : pool[Math.floor(nextRandom(s) * pool.length)]!;
    const a = (i / guards) * Math.PI * 2;
    s.enemies.push(makeEnemy(s, def, x + Math.cos(a) * GUARD_RING, y + Math.sin(a) * GUARD_RING, enemyHealth(s, def)));
  }
}
